
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/7big-secrets-to-180",
      function () {
        return require("private-next-pages/7big-secrets-to-180/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/7big-secrets-to-180"])
      });
    }
  